<template>
  <div>
    <ModalHomologa v-if="modalHomologacao">
      <div class="modal-header">
        <h3><strong>N° RRIM:</strong> {{ dados.InforGeral.IGRRIM }}</h3>
        <h3><strong>Molde:</strong> {{ dados.InforGeral.IGMolde }}</h3>
        <h3><strong>Cliente:</strong> {{ dados.InforGeral.IGCliente }}</h3>
      </div>

      <div class="modal-comentario">
        <span><strong>Comentario:</strong></span>
        <textarea style="width: 100%" class="textarea_hom" v-model="ComentarioHomolgacao" rows="7">
        </textarea>
      </div>

      <div class="modal-buttons">
        <button class="btn-modal cancelar" @click="fecharModalHomolacao">Cancelar</button>
        <button class="btn-modal reprovar" @click="showModalConfirmacao(false)">
          Reprovar
        </button>
        <button class="btn-modal" @click="showModalConfirmacao(true)">
          Aprovar
        </button>
      </div>

      <div class="modal-confirmacao" v-if="showConfirmacao">
        <span v-if="statusHomologacao">Sim, eu desejo confirmar a <strong>APROVAÇÃO</strong> desta
          RRIM</span>
        <span v-if="!statusHomologacao">Sim, eu desejo confirmar a <strong>REPROVACAO</strong> desta
          RRIM</span>
        <div class="confirmacao-buttons">
          <button class="btn-modal" @click="homologar(statusHomologacao, dados.InforGeral.IGRRIM)">
            Sim, confirmar
          </button>
        </div>
      </div>
    </ModalHomologa>
    <transition name="model">
      <form @submit.prevent="submitForm">
        <div class="modal_mask">
          <div class="modal_content">
            <div class="modal_header">
              <div class="title_modal">
                <div class="flex">
                  <h4>Visualizar RRIM</h4>
                  <button @click="finish_modal" class="close_button">
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-body">
              <div class="card-header">
                <ul class="nav nav-tabs card-header-tabs">
                  <li class="nav-item">
                    <a :class="active_rrim" @click="click_rrim">RRIM</a>
                  </li>
                  <li class="nav-item">
                    <a :class="active_fotos" @click="click_fotos">Fotos</a>
                  </li>
                  <li class="nav-item">
                    <a :class="active_lsp" @click="click_lsp">LSP</a>
                  </li>
                </ul>
              </div>

              <div class="tab-content">
                <div v-show="rrim">
                  <RRIM :configInputs="1" @setObjOfInforGeral="getObjOfInforGeral" @setListPro="getListPro"
                    @setObjMoldeFechado="getObjMoldeFechado" @setObjMoldeAberto="getObjMoldeAberto" />
                </div>

                <div v-show="fotos" class="fotos">
                  <FOTOS :configInputs="1" @SendDataImages="getObjAllImages" />
                </div>

                <div v-show="lsp">
                  <LSP :configInputs="1" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button v-if="homologation && role === 'eng_admin'" class="btn btn-blue" @click="openModalHomologation">
                Homologar
              </button>
              <button type="button" class="btn btn-light font-weight-bold" @click="Modalcancelar" data-dismiss="modal">
                Cancelar
              </button>
              <button if="dados." type="button" class="btn btn-light font-weight-bold" @click="exportar"
                data-dismiss="modal">
                Exportar
              </button>
              <!-- <button type="submit" class="btn btn-success font-weight-bold">
                Salvar
              </button> -->
            </div>
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>


<script>
import RRIM from "./Modules/RRIM/LayoutView.vue";
import FOTOS from "./Modules/FOTOSRRIM/LayoutView.vue";
import LSP from "./Modules/LSP/LayoutView.vue";
import useVuelidate from "@vuelidate/core";
import ModalHomologa from "@/components/Modais/ModalHomologa.vue";
import { api } from "../../../http/index";

// import { required, minLength } from '@vuelidate/validators'

export default {
  components: {
    RRIM,
    FOTOS,
    LSP,
    ModalHomologa
  },
  props: {
    homologation: {
      type: Boolean,
      required: false
    },
    role: {
      type: String,
      required: false
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      statusHomologacao: false,
      modalHomologacao: false,
      showConfirmacao: false,
      ComentarioHomolgacao: '',
      active_rrim: "font-weight-bold nav-link text-success",
      active_fotos: "font-weight-bold nav-link text-success",
      active_lsp: "font-weight-bold nav-link text-success",
      vmodal: true,
      rrim: true,
      fotos: false,
      lsp: false,

      dados: {
        InforGeral: Object,
        Produtos: Object,
        Molde_Fechado: Object,
        Molde_Aberto: Object,
      },
      dadosImages: Object,
    };
  },
  mounted() {
    document.body.classList.add('sc');
  },
  beforeUnmount() {
    document.body.classList.remove('sc');
  },
  methods: {
    async exportar() {
      const data = await this.$store.getters.$GetDataAllRRIM;
      const toast = await this.$swal
        .fire({
          title: "Deseja exportar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const exportDocument = this.$router.resolve({
        path: "/export",
        query: { id: data.InforGeral.ID },
      });

      window.open(exportDocument.href, "_blank");

      this.$store.commit("MutationSetCancelModalViewRRIM", true);
    },

    showModalConfirmacao(valorConfirmacao) {
      this.statusHomologacao = valorConfirmacao;
      this.showConfirmacao = true;
    },

    openModalHomologation() {
      this.modalHomologacao = true
    },

    fecharModalHomolacao() {
      this.modalHomologacao = false
    },

    async homologar(valorConfirmacao, rrim) {
      const match = rrim.match(/\d+/)
      let newRrim = Number(match[0])

      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (
        this.ComentarioHomolgacao === ''
      ) {
        Toast.fire({
          icon: "success",
          title: "Você deve adicionar um comentário!",
        });
      }

      if (valorConfirmacao) {
        await api
          .put(`/rrim/homologation/${newRrim}`, {
            status: 2,
            comentario: this.ComentarioHomolgacao,
          })
          .then((res) => {
            Toast.fire({
              icon: "success",
              title: "RRIM Aprovada!",
            });
          });
      } else {
        await api
          .put(`/rrim/homologation/${newRrim}`, {
            status: 3,
            comentario: this.ComentarioHomolgacao,
          })
          .then((res) => {
            Toast.fire({
              icon: "success",
              title: "RRIM Reprovada!",
            });
          });
      }
      window.location.reload();
    },

    async Modalcancelar() {
      // const toast = await this.$swal
      //   .fire({
      //     title: "Deseja cancelar Visualização de RRIM ?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     cancelButtonText: "Cancelar",
      //     confirmButtonColor: "green",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "Confirmar",
      //   })
      //   .then((result) => {
      //     if (result.isConfirmed) {
      //       return true;
      //     }

      //     return false;
      //   });

      // if (!toast) {
      //   return;
      // }
      this.$store.commit("MutationSetCancelModalViewRRIM", false);
    },
    click_rrim() {
      this.rrim = true;
      this.fotos = false;
      this.lsp = false;
      this.active_rrim = "font-weight-bold nav-link text-success active";
      this.active_fotos = "font-weight-bold nav-link text-success ";
      this.active_lsp = "font-weight-bold nav-link text-success ";
    },

    click_fotos() {
      this.rrim = false;
      this.fotos = true;
      this.lsp = false;
      this.active_fotos = "font-weight-bold nav-link text-success active";
      this.active_rrim = "font-weight-bold nav-link text-success";
      this.active_lsp = "font-weight-bold nav-link text-success ";
    },

    click_lsp() {
      this.rrim = false;
      this.fotos = false;
      this.lsp = true;
      this.active_fotos = "font-weight-bold nav-link text-success ";
      this.active_rrim = "font-weight-bold nav-link text-success";
      this.active_lsp = "font-weight-bold nav-link text-success active";
    },

    finish_modal() {
      this.$store.commit("MutationSetCancelModalViewRRIM", false);
      this.vmodal = !this.vmodal;
    },

    getObjOfInforGeral(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.InforGeral = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getListPro(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Produtos = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjAllImages(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dadosImages = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjMoldeFechado(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Molde_Fechado = val;
      this.$store.commit("SetLoadingPattern", false);
    },

    getObjMoldeAberto(val) {
      this.$store.commit("SetLoadingPattern", true);
      this.dados.Molde_Aberto = val;
      this.$store.commit("SetLoadingPattern", false);
    },
  },
};
</script>


<style scoped>
input:disabled {
  background: #6666663d;
}

.modal-open {
  overflow: hidden;
}

ul li {
  cursor: pointer;
}

.modal-body {
  width: 100%;
}

.card_end {
  justify-content: flex-end;
  display: flex;
}

.flex {
  display: flex!important;
  flex-direction: row!important;
  justify-content: space-between;
}

.close_button{
  background-image: url("../../../static/icons/close_icon.svg");
  background-repeat: no-repeat;
  background-size: 70%;
  background-position: center;
  margin-right: -2.5rem;
  width: 3.8rem;
  background-color: rgba(255, 0, 0, 0);
}

.btn-blue {
  color: var(--blue);
  font-weight: 700;
}

.title_modal input {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.title_modal input:hover {
  width: 2vw;
  height: 2vw;
  border-radius: 8px;
  background: var(--red);
  color: var(--white);
  border: none;
  font-size: 0.8vw;
}

.modal_mask {
  position: fixed;
  display: block;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  background: #c5c5c5d6;
  overflow: auto;
}

.modal_mask .modal_content {
  position: relative;
  width: 65%;
  /* height: 90%;   TAMANHO DE CARRAGAER NOVO RRIM*/
  margin: 13vh auto;
  background: var(--white);
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.modal_mask .modal_content .modal_header {
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;

  background: var(--green);
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.modal_mask .modal_content .modal_header .title_modal {
  width: 90%;
  margin: auto;
  color: var(--white);
  font-size: 1.5rem;
  text-align: start;
  align-items: center;
  justify-content: space-between;
}

.column_1 {
  overflow-y: scroll;
}

.column_2 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.modal_mask .modal_body {
  width: 98%;
  /* height: 90%; */
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
  /* overflow-y: scroll; */
  padding: 0 15px;
  display: grid;
  gap: 1vw;
  grid-template-columns: 3.7fr 1fr;
}

.modal_mask .modal_body .cards {
  width: 100%;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  text-align: start;
}

.modal_mask .modal_body .cards .card_informations {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--white);
  padding: 20px;
  border-radius: 10px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.mx-3 {
  margin-left: 1rem !important;
}

.modal_mask .modal_body .cards .card_informations .title {
  width: 100%;
  color: var(--green);
}

.nav-pills .nav-link {
  border-radius: 0.35rem;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: var(--white);
  background-color: var(--green);
}

.modal_mask .modal_body .button_modal {
  width: 100%;
  position: relative;
  grid-column: 1/4;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: flex-end;
  padding: 25px;
  justify-items: end;
  display: flex;
}

.modal-header {
  padding: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
}

.modal-comentario {
  padding: 1rem;
}

.sem-borda {
  font-weight: 600;
  color: var(--orange);
  background-color: transparent;
  text-decoration-line: underline;
}

.modal-comentario textarea {
  border-radius: 0.25rem;
  padding: 0.5rem;
}

.modal-confirmacao {
  padding: 1rem;
  margin-top: 2rem;
  border-top: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.modal-buttons {
  padding: 1rem;
  display: flex;
  justify-content: end;
  width: 100%;
  gap: 1rem;
}

.btn-modal {
  width: 8rem;
  height: 2.2rem;
  color: #fff;
  border-radius: 0.25rem;
  background-color: var(--green);
}

.reprovar {
  background-color: var(--orange);
}

.cancelar {
  background: #ff8c00;
}

.table-content {
  overflow-y: scroll;
  /* height: 20
rem
; */
  height: 80vh;
}

.card-header {
  width: 100%;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: var(--white);
  border-bottom: 1px solid var(--cinza);
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-tabs .nav-link.active {
  color: var(--grey);
  background-color: var(--white);
  border-color: #dddfeb #dddfeb #fff;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.text-success {
  color: var(--green) !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

a {
  color: var(--green);
  text-decoration: none;
  background-color: transparent;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.modal-footer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid var(--grayBody);
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

@media (max-width: 1240px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1100px) {
  .modal_mask .modal_body .button_modal {
    grid-template-columns: 3fr 1fr;
  }
}

@media (max-width: 907px) {
  .modal_mask .modal_body .cards {
    grid-template-columns: 1fr;
  }

  .modal_mask .modal_body .button_modal {
    grid-template-columns: 2fr 1fr;
  }
}

@media (max-width: 780px) {
  .modal_mask .modal_body .title {
    text-align: center;
  }

  .modal_mask .modal_body .button_modal {
    grid-template-columns: 1fr;
    padding: 15px 0;
    grid-gap: 10px;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 768px) and (min-width: 426px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 425px) {
  .modal_mask .modal_content {
    width: 95%;
    font-size: 12px;
    position: relative;
    /* width: 65%; */
    margin: 30px auto;
    background: var(--white);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }
}
</style>
